import request from './request';

const education_background = {
	async getEducationBackgroundByApplicationId(id) {
		const response = await request.get(`/app/education-bg/id?id=${id}`);
		return response;
	},
	async createEducationBackground(body) {
		const response = await request.post('/app/education-bg', body);
		return response;
	},
	async updateEducationBackground(id,body) {
		const response = await request.patch('/app/education-bg/', body);
		return response;
	}
};

export default education_background;